const matchPath = (tabPath, currentPath) => {
  const replacedPath = tabPath.replaceAll(/(:[a-zA-Z0-9_]+)/g, '[a-zA-Z0-9-_]+')
  const regex = new RegExp(`^${replacedPath}$`)

  return regex.test(currentPath)
}

export const getTabTitles = (tabs, selectedTab, currentPath, childPageTitle) => {
  let titles = { parent: null, page: null, childPage: null }
  const parent = tabs?.find(t => t?.children?.find(tc => tc.id === selectedTab?.id))
  titles.parent = parent ? parent : selectedTab
  titles.page = parent ? selectedTab : null

  if (selectedTab?.pages) {
    const childPath = selectedTab.pages.find(t => matchPath(t.path, currentPath))

    if (childPath) {
      titles.childPage = { label: childPageTitle || childPath.label }
    }
  }

  return titles
}
